import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { PropertySize } from "Globals/Models/PropertySize";

export class PropertySizeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private propertySizes: PropertySize[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.propertySizes = initialState.propertySizes;
    }

    @MobX.action
    public getPropertySizeName(propertySizeId: string | null): string {
        if (propertySizeId == null) return "";
        if (propertySizeId == "0") return "Error";
        if (propertySizeId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => propertySizeId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): PropertySize[] {
        return this.propertySizes.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getPropertySizeOptions(): KeyValuePair[] {
        return this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];
    }
}
